module.exports = __webpack_public_path__ + "static/media/b1.77f7608a.png";